import React from 'react';
import { LinearNavigationProvider as CoreProvider, LinearNavigationItem } from "@shapeable/ui"
import { useRegions } from "../../hooks/use-regions"

export const LinearRegionNavigationProvider: React.FC<any> = ({ children }) => {

  const items: LinearNavigationItem[] = [];

  const regions = useRegions();

  for (const region of regions) {
    if (region.children.length > 0) continue;

    items.push({
      id: region.id,
      name: region.name,
      depth: 0,
      path: region.path,
      slug: region.slug,
      parent: null,
    });
  }

  return (
    <CoreProvider value={items}>
      {children}
    </CoreProvider>
  )
  
}